import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'fms-card-title',
	templateUrl: 'card-title.component.html',
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [],
})
export class CardTitleComponent {}
